import React from 'react'
import { createRoot } from 'react-dom/client'
import { FlashcardApp } from './components/App'

export const startFlashcardApp = (flashcards, chapters) => {
  const root = createRoot(document.getElementById('flashcardQuizContainer'))
  root.render(<FlashcardApp flashcards={flashcards} chapters={chapters} />)
}
